var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('img',{attrs:{"src":require("@/assets/AnimatedLogo.gif")}})])],1),_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Thanks for attending!")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }